import followOnJobService from '@/http/services/followonjob'
import store from '../../../store'
export default {
  getBooking ({ commit }, id) {
    return followOnJobService.getBooking(store.state.apiUrl, id).then((booking) => {
      commit('setBooking', booking.data)
    })
  },
  updateFollowOnJobsPriority ({commit}, data) {
    return followOnJobService.updateFollowOnJobsPriority(store.state.apiUrl, data).then((response) => {
      return response.data
    })
  },
  getFollowOnJobsForTaxi ({ commit }, taxiId) {
    return followOnJobService.getFollowOnJobsForTaxi(store.state.apiUrl, taxiId).then((booking) => {
      commit('setFollowOnJobsForTaxi', booking.data)
    })
  }
}
